import ManageUnits from "../../components/manage/ManageMatrix";
import ManageUsers from "../../components/manage/ManageUsers";

export default function Manage() {
  return (
    <div className="">
      <div className="m-1">
        <div className="grid grid-cols-12 gap-1">
          <ManageUnits />
          <ManageUsers />
        </div>
      </div>
    </div>
  );
}
